// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"94eee612","344":"204288e5","375":"fade7aef"}[chunkId] + ".chunk.js";
};